import React from 'react';
import { Box, Grid, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { urlDPTrainingVideos, loomFlags } from 'util/EnumHelper';
import { localize } from 'util/Localizer';
import StyledHeaderContainer from 'components/Common/StyledHeaderContainer/StyledHeaderContainer';
import DPApp from 'components/DPApp';
import CollapsableVideo from 'components/Resources/CollapsableVideo';
import Sidebar from 'components/Resources/Sidebar';
import withRouter from 'util/customHooks/withRouter';

const CollapseContainer = styled(Grid)(({ theme }) => ({
    margin: '0px',
    width: '100%',
    paddingRight: '16px',
    [theme.breakpoints.down('md')]: {
        paddingRight: '0px',
        paddingBottom: '16px'
    }
}));

const VideoContainer = styled(Grid)(({ theme }) => ({
    align: 'center',
    textAlign: 'center',
    justify: 'center',
    justifyItems: 'center',
    alignItems: 'center',
    direction: 'row',
    width: '100%',
    paddingLeft: '16px',
    [theme.breakpoints.down('md')]: {
        paddingLeft: '0px',
        paddingTop: '16px'
    }
}));

function Resources({ router }) {
    const { location } = router;

    return (
        <DPApp>
            <StyledHeaderContainer
                extraStyle={{padding: '34px 0 51px 0px'}}
                title={localize('resources.title')}
                testId="resourcesHeader"
            />
            <Grid container sx={{ padding: '32px' }}>
                <CollapseContainer item md={8} sm={12}>
                    <Sidebar isRouteOpen={location?.state?.isRouteDetailExpanded} />
                </CollapseContainer>
                <VideoContainer item md={4} sm={12}>
                    {
                        urlDPTrainingVideos.map(
                            (video) => (
                                <Paper data-testid={`videoPaper${video.sortId}`}
                                    key={video.sortId}
                                    sx={{
                                        p: '32px',
                                        borderRadius: '8px',
                                        width: '100%'
                                    }}
                                >
                                    <Box key={video.sortId}
                                        data-testid={`videoWrapperBox${video.sortId}`}
                                        sx={{ px: '0px' }}
                                    >
                                        <CollapsableVideo
                                            sortId={video.sortId}
                                            testId={`collapsableVideo${video.sortId}`}
                                            videoTitle={video.title}
                                            videoUrl={`${video.url}${loomFlags}`}
                                            videoDescription={localize(video.description)}
                                            videoLength={video.length}
                                        />
                                    </Box>
                                </Paper>
                            ))
                    }
                </VideoContainer>
            </Grid>
        </DPApp>
    );
}

Resources.defaultProps = {
    router: {
        location: {
            state: {
                isRouteDetailExpanded: false
            }
        }
    }
};

Resources.propTypes = {
    router: PropTypes.shape({
        location: PropTypes.shape({
            state: PropTypes.shape({
                isRouteDetailExpanded: PropTypes.bool
            })
        })
    })
};

export default withRouter(Resources);
